import React, { useContext } from 'react';
import { Alert, Spinner } from 'react-bootstrap';
import AuthContext from '../context/AuthContext';

// Components
import DataTable from '../components/common/DataTable';
import AuditLogRow from '../components/audit/AuditLogRow';

// Hooks
import { useAuditLogs } from '../hooks/useAuditLogs';

const AuditLog = () => {
  const { user, loading: authLoading } = useContext(AuthContext);
  
  const {
    logs,
    loading,
    error,
    fetchLogs,
    handleRollback
  } = useAuditLogs(user, authLoading);

  const tableHeaders = [
    { label: 'Time', width: '150px' },
    { label: 'User', width: '150px' },
    { label: 'Project', width: '150px' },
    { label: 'Action', width: '100px' },
    { label: 'Object', width: '120px' },
    { label: 'Details' }
  ];

  if (authLoading) {
    return (
      <div className="p-5 text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2 text-muted">Verifying credentials...</p>
      </div>
    );
  }

  if (user?.type !== 'admin') {
    return <Alert variant="danger" className="mt-4 shadow-sm">Access Denied: Administrator role required.</Alert>;
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Audit Trail</h1>
        <button 
          onClick={fetchLogs} 
          className="btn btn-outline-secondary btn-sm shadow-sm"
          disabled={loading}
        >
          <i className={`fas fa-sync mr-1 ${loading ? 'fa-spin' : ''}`}></i> 
          {loading ? 'Refreshing...' : 'Refresh Logs'}
        </button>
      </div>

      {error && <Alert variant="warning" className="small border-0 shadow-sm">{error}</Alert>}

      <DataTable 
        headers={tableHeaders}
        data={logs}
        loading={loading}
        emptyMessage="No activity recorded in the audit trail yet."
        renderRow={(log) => (
          <AuditLogRow 
            key={log._id} 
            log={log} 
            onRollback={handleRollback} 
          />
        )}
      />
    </div>
  );
};

export default AuditLog;
